import { render, staticRenderFns } from "./FavExercise.vue?vue&type=template&id=77d80ee4&scoped=true&"
import script from "./FavExercise.vue?vue&type=script&lang=js&"
export * from "./FavExercise.vue?vue&type=script&lang=js&"
import style0 from "./FavExercise.vue?vue&type=style&index=0&id=77d80ee4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d80ee4",
  null
  
)

export default component.exports